import { requests } from "../index";
import URLS from "../endPoints";
import request from "superagent";

import axios from "axios";

let Bookmark = {};
Bookmark.AddBookmark = async (payload) =>
  await requests.post(URLS.magUrl.insertbookmark, payload);

Bookmark.GetAllBookmarks = async (payload) => await requests.post(URLS.magUrl.getallbookmark, payload);
export default Bookmark;
